import React from 'react';
import PropTypes from 'prop-types';
import { Text, Flex, Box, useTheme } from '@chakra-ui/react';
import { MdArrowForward } from 'react-icons/md';

import Image from '@rsc/ui-components/tailwind/Image';
import Link from '@rsc/ui-components/tailwind/Link';

function AuthorCard({ author }) {
  const theme = useTheme();

  return (
    <Box
      as={Link}
      link={
        author?.slug?.current
          ? `/blog/author/${author?.slug?.current}`
          : '/blog'
      }
    >
      <Box
        borderRadius="lg"
        border="1px solid"
        borderColor="stroke.light"
        pt={8}
        pb={4}
        px={4}
        h="223px"
        background="white"
        pos="relative"
        _hover={{
          border: '0px',
          boxShadow: theme.cardBoxShadow,
          '#border': {
            borderBottom: '3px solid',
            borderColor: 'brand.sunny',
          },
          '#icon': {
            display: 'flex',
          },
        }}
      >
        <Flex
          gap={4}
          pb={4}
          borderBottom="1px solid"
          borderColor="stroke.light"
          id="border"
        >
          <Box>
            <Image
              className="rounded"
              sanityImage={author.image}
              srcSetBasisWidth={71}
              width="71px"
            />
          </Box>
          <Text textStyle="h4_5_6" as="h4" fontSize="md" fontWeight="semibold">
            {author.title}
          </Text>
          <Flex
            background="brand.sunny"
            borderRadius={30}
            width={10}
            height={10}
            alignItems="center"
            justifyContent="center"
            position="absolute"
            right="12px"
            top="12px"
            id="icon"
            display="none"
          >
            <MdArrowForward size="24px" />
          </Flex>
          <Box w="24px" />
        </Flex>
        <Text fontWeight="semibold" mt={4}>
          {author.occupation}
        </Text>
      </Box>
    </Box>
  );
}

AuthorCard.propTypes = {
  author: PropTypes.shape({
    image: PropTypes.shape({
      asset: PropTypes.shape({
        url: PropTypes.string,
      }),
      alt: PropTypes.string,
    }),
    title: PropTypes.string,
    occupation: PropTypes.string,
    slug: PropTypes.shape({
      current: PropTypes.string,
    }),
  }).isRequired,
};

export default AuthorCard;
